import React, { useRef, useState } from 'react';
import Paper from '@mui/material/Paper/Paper';
import TextField from '@mui/material/TextField/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useSignIn } from '../../api/hooks/auth';
import { Box } from '@mui/material';

export default function SignInFrom() {
  const signIn = useSignIn();
  const phoneRef = useRef();
  const passRef = useRef();

  const [error, setError] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await signIn.mutateAsync({
        password: passRef.current.value,
        phoneNumber: phoneRef.current.value,
      });
    } catch {
      setError(true);
    }
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        textAlign: 'center',
        p: [10, 10, 3, 10],
        borderColor: 'primary.main',
      }}
    >
      <form onSubmit={handleSubmit}>
        <Box sx={{ my: 2 }}>
          <TextField
            label="شماره تلفن"
            variant="filled"
            size="small"
            type="tel"
            fullWidth
            inputRef={phoneRef}
            error={error}
          />
        </Box>
        <Box sx={{ my: 2 }}>
          <TextField
            label="رمز عبور"
            variant="filled"
            size="small"
            type="password"
            fullWidth
            inputRef={passRef}
            error={error}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          sx={{
            mt: 4,
            color: 'white',
          }}
          fullWidth
          type="submit"
        >
          ورود
        </Button>
      </form>

      <Typography color="textSecondary" variant="subtitle2" sx={{ mt: 10 }}>
        پنل مدیریت تامین | فروش |‌ ضمانت <b>افاق‌تل</b>
      </Typography>
    </Paper>
  );
}
